function i(i){return{id:i.id}}export{i as shopifyShopToUnlikelyShop};
//# sourceMappingURL=serializers.js.map
